import React, { FC, ReactNode } from 'react';
import classNames from 'classnames/bind';

import { ACCUMS_TEXTS } from 'constants/accumulators';
import { AdditionalAccExpirationText } from 'components/Accumulator/AdditionalAccExpirationText';
import { AccumulatorsSkeleton } from 'components/AccumulatorsSkeleton';
import { ErrorData } from 'components/ErrorData';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type AccumulatorsBlockProps = {
  accumulatorListSlot: ReactNode;
  additionalBillingInfo?: string;
  hasError?: boolean;
  infoTagSlot: ReactNode;
  isMobile?: boolean;
  isPending?: boolean;
  onRefreshButtonClick: () => void;
  tariffSettingButtonSlot: ReactNode;
  tariffUrl: string;
};

export const AccumulatorsBlock: FC<AccumulatorsBlockProps> = ({
  tariffUrl,
  isPending,
  hasError,
  onRefreshButtonClick,
  additionalBillingInfo,
  accumulatorListSlot,
  tariffSettingButtonSlot,
  infoTagSlot,
  isMobile = true,
}) => {
  return (
    <>
      <a aria-label="Ссылка на детали тарифа" className={cn('block-link')} href={tariffUrl}>
        {accumulatorListSlot}
        <AdditionalAccExpirationText
          additionalBillingInfo={additionalBillingInfo}
          className={cn('additional-acc-expiration-text')}
          isMobile={isMobile}
          shouldRender={!!additionalBillingInfo}
        />
        {infoTagSlot}
      </a>
      {tariffSettingButtonSlot}
      {isPending && <AccumulatorsSkeleton />}
      {hasError && (
        <div className={cn('error-block')}>
          <ErrorData onClick={onRefreshButtonClick} text={ACCUMS_TEXTS.error} />
        </div>
      )}
    </>
  );
};
